import React from 'react'
import { HStack, Text, IconButton } from '@chakra-ui/react'
import { VIEW_AS } from '../consts'

export const ViewAsSelector = ({ viewAs, setViewAs }) => {

    const bgSelected = '#484848'
    const bgUnselected = '#F5F6F7'
    const iconColorSelected = 'white'
    const iconColorUnselected = '#484848'

    return (
        <HStack spacing={3}>
            <Text fontSize="sm" color="gray.600">
                View as: <b>{viewAs.name}</b>
            </Text>

            {VIEW_AS.map((option) => {
                const Icon = option.icon
                const isSelected = viewAs.id === option.id

                return (
                    <IconButton
                        key={option.id}
                        aria-label={option.name}
                        icon={<Icon size="20px" />}
                        size="sm"
                        borderRadius="full"
                        bg={isSelected ? bgSelected : bgUnselected}
                        color={isSelected ? iconColorSelected : iconColorUnselected}
                        _hover={{ bg: isSelected ? bgSelected : '#E1E1E1' }}
                        onClick={() => setViewAs(option)}
                    />
                )
            })}
        </HStack>
    )
}
